import { Decimal } from "decimal.js";

const format = (value, fallback, precision, unit) => {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  return `${Decimal(value).toFixed(precision)} ${unit}`;
};

export const formatVolume = (value, fallback = "-") => format(value, fallback, 1, "m³");

export const formatMass = (value, fallback = "-") => format(value, fallback, 3, "kg/m³");

export const formatWeight = (value, fallback = "-", unit = "kg") => format(value, fallback, 2, unit);

export const formatPercentual = (value, fallback = "-") => format(Decimal.mul(value, 100), fallback, 2, "%");

const pad2 = (n) => String(n).padStart(2, "0");

export const formatElapsedMs = (ms) => {
  const totalSeconds = Math.floor(ms / 1000);
  const hh = Math.floor(totalSeconds / 3600);
  const mm = Math.floor((totalSeconds % 3600) / 60);
  const ss = totalSeconds % 60;

  return hh > 0
    ? `${pad2(hh)}:${pad2(mm)}:${pad2(ss)}`
    : `${pad2(mm)}:${pad2(ss)}`;
};
